var map = {
	"./buy_normal_cn.png": 74039,
	"./buy_normal_en.png": 87389,
	"./buy_normal_id.png": 5187,
	"./buy_normal_ko.png": 60406,
	"./buy_normal_ph.png": 41660,
	"./buy_normal_th.png": 69520,
	"./buy_normal_zh.png": 12462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60821;